import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { getTenantSchemaAllEvents } from '../api/tenantSchemaApi';
import { DataTable } from '../components/DataTable';
import { ErrorState } from '../components/ErrorState';
import { LoadingState } from '../components/LoadingState';
import { PageShell } from '../components/PageShell';

export function TenantSchemaEventsPage() {
  const { t } = useTranslation(['tenantSchema', 'common']);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getTenantSchemaAllEvents({ per_page: 100 });
      setRows(response.data || []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const columns = useMemo(() => [
    { id: 'tenant_id', label: t('tenantSchema:events.columns.tenant'), render: (row) => row.tenant_id ? <RouterLink to={`/tenants/${row.tenant_id}`}>{t('tenantSchema:dashboard.tenant_link', { id: row.tenant_id })}</RouterLink> : t('common:empty_value') },
    { id: 'event_type', label: t('tenantSchema:events.columns.event'), render: (row) => t(`tenantSchema:event_types.${row.event_type}`, row.event_type) },
    { id: 'message', label: t('common:message') },
    { id: 'created_at', label: t('tenantSchema:events.columns.at') },
  ], [t]);

  if (loading) return <LoadingState />;
  if (error) return <ErrorState message={t('tenantSchema:events.load_failed')} onRetry={load} />;

  return (
    <PageShell title={t('tenantSchema:events.title')} subtitle={t('tenantSchema:events.subtitle')}>
      <DataTable columns={columns} rows={rows} rowKey="id" emptyMessage={t('tenantSchema:events.no_events')} />
    </PageShell>
  );
}
